document.addEventListener('DOMContentLoaded', () => {
    const influencersSlider = new Swiper('.influencers__slider', {
        slidesPerView: "auto",
        loop: true,
        centeredSlides: true,
        enabled: true,
        slideToClickedSlide: true,
        autoplay: {
            delay: 5000,
            pauseOnMouseEnter: true,
            disableOnInteraction: false
        },
        breakpoints: {
            768: {
                enabled: false
            }
        }
    })
});